



















































import {Component, Mixins} from 'vue-property-decorator';
import EditDialog from '@/components/EditDialog.vue';
import EditDialogMixin from '@/mixins/EditDialogMixins';
import enumsModule from '@/store/modules/enumsModule';
import {httpClient} from '@/api/baseApi';

@Component({
  components: {EditDialog},
})
export default class CleanModuleSettingsEditDialog extends Mixins(EditDialogMixin) {
  nonEmptyTextRule = (v: any) => !!v || (v && v.length === 0) || 'Поле обязательно для заполнения';
  timeoutRule = (v: any) =>
    /^((([1-9]+\d*)+y[ ]?)?(([1-9]+\d*)+m[ ]?)?(([1-9]+\d*)+d[ ]?)?(([1-9]+\d*)+h[ ]?)?|([1-9]+\d*)+)$/.test(
      v,
    ) || 'Значение должно быть в формате: [[[[00y]00m]00d]00h | 00]';

  get moduleTypeNames() {
    this.moduleDefaultValues = [];
    const modules = enumsModule.moduleTypes.map(x => ({
      type: x.value,
      name: x.description.replace('dtcp ', ''),
      url: x.url,
    }));
    return modules;
  }

  get eventTypeNames() {
    if (this.moduleDefaultValues.length === 0 && this.data.module) {
      this.getEventTypes();
    }
    return this.moduleDefaultValues
      ? this.moduleDefaultValues.map(v => ({description: v.description, type: v.type}))
      : null;
  }

  async getEventTypes() {
    const currentModuleType = enumsModule.moduleTypes.find(v => v.value === this.data.module.type);
    if (currentModuleType) {
      const moduleParametersResponse: {data: any} = await httpClient.get(
        `${currentModuleType.url}/events/event_types`,
      );
      this.moduleDefaultValues = moduleParametersResponse?.data ?? [];
    }
  }

  async onModuleChange() {
    this.data = {...this.data, event: null};
    this.moduleDefaultValues = [];
    await this.getEventTypes();
  }

  // необходимо заполнять настройку полностью
  saveWithCheck() {
    if (!this.data.timeout || !this.data.module || !this.data.event) {
      this.setupErrors({'common': ['Все параметры должены быть заполнены']});
      return;
    }
    this.save();
  }
}
